export const hasPermission = (permission_name) => {
  const permissions = JSON.parse(localStorage.getItem("permissions"))
    ? JSON.parse(localStorage.getItem("permissions"))
    : [];

  return permissions.find((e) => e === permission_name);
};
